module.exports = __webpack_public_path__ + "media/images/clipboard-a9c1357c0fc9edd9d21cec0a3e047a94.svg";